module.exports = __webpack_public_path__ + "bd3bc6fac5a34d9a12b7e0e1f95676ab.png";